exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".description[_v-291cd1f8]{font-family:Roboto,sans-serif;line-height:1.5}.description__body-wrapper__text[_v-291cd1f8]{height:50px;display:-webkit-box;-webkit-line-clamp:4;overflow:hidden}.description__button[_v-291cd1f8]{padding:0;margin:0;background:transparent;border:0;font-size:1rem;cursor:pointer;font-weight:600}.description__button[_v-291cd1f8]:hover{opacity:.8}.description__button-placeholder[_v-291cd1f8]{height:24px}.description__heading[_v-291cd1f8]{font-size:1.25rem;margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-291cd1f8&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/v3-components/Description.vue
// module id = 278
// module chunks = 0